module.exports = __webpack_public_path__ + "static/media/PxGroteskLight.48b05c98.ttf";